//
//
//
//
//
//
//
//
//
//
//
//
//
import actionCableMixin from "./mixins/ws/actionCable";
import textMixin from "./mixins/text.js";
export default {
  mixins: [actionCableMixin, textMixin],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      text: " "
    };
  },
  methods: {
    $ready: function $ready() {
      this.$wsInitActionCable(this.spec.actionCable);
      this.text = this.spec.text;
    },
    action_set: function action_set(spec) {
      if (spec.user_id !== spec.filterKey) {
        this.text = spec.text;
      }
    }
  }
};